module.exports = __webpack_public_path__ + "img/Cultura.1d817adc.svg";